import React, { useEffect, useState } from "react";
import "../../../index.scss";
import { FormattedMessage } from "react-intl";
import SalePointDefaultImg from "../../../assets/market-icons/punto-de-venta.jpg";
import { Link, useLocation } from "react-router-dom";
import EditIcon from "../../../assets/icons/white-create-24px.svg";
import {
  FormControlLabel,
  Snackbar,
  MenuItem
} from "@material-ui/core";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import MuiAutocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import LinearProgress from "@mui/material/LinearProgress";

import CreatableSelect from "react-select/creatable";
import CustomTable from "../../../components/Table/Table";
import EditPrimaryIcon from "../../../assets/icons/edit-icon-24px.svg";

import {
  postFranchise,
  putFranchise,
  getFranchiseSchedule,
  postScheduleFranchise,
  putScheduleFranchise,
  deleteScheduleFranchise,
} from "../../../services/utilsFranchise/utilsFranchise";
// import { getFranchiseTypes } from "../../../services/utilsFranchiseType/utilsFranchiseType";
// import GoogleApiWrapper from "../../../components/supervisor/GoogleMap/Map";
import SimpleMap from "../../../components/supervisor/GoogleMap/GoogleMap";
import "./FranchiseForm.scss";
import { Alert } from "@mui/material";
import { useHistory } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
// import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import { getAllSalePointType } from "../../../services/utilsSalePointType";
import {
  getCoursesBySalePoint,
  getSalePoint,
  getSalePointById,
  getAllSalePoint,
} from "../../../services/utilsSalePoint";
import {
  getPaginatedProductCategories,
  getProductCategory,
  postProductCategory,
  putProductCategory,
} from "../../../services/utilsProductCategory/utilsProductCategory";
import RelatedCoursesComponent from "../../../components/supervisor/SalePoint/RelatedCoursesComponent";
import { getCoursesByOrganization } from "../../../services/utilsCourses/utilsCourses";
import {
  getProductsOfTag,
  getRestrictedProductsOfSalePoint,
  getTagsOfOrganization,
  getTagsOfSalePoint,
  modifyTagWithSalePoint,
} from "../../../services/utilsTags";
import TagInput from "../../../components/TagsInput/TagInput";
import RowProduct from "../../../components/RowProduct/RowProduct";
// import { TimePicker } from '@mui/x-date-pickers';


export const SalePointForm = () => {
  // ----------------------------------------------------
  // ------------- Variables & Constants ----------------
  // ----------------------------------------------------

  const [salePointTypeList, setSalePointTypeList] = useState();

  const [selectedSpt, setSelectedSpt] = useState([]);

  const [salePointId, setSalePointId] = useState(
    localStorage.getItem("fk_sale_point")
  );

  const [organizationId, setOrganizationId] = useState(
    localStorage.getItem("fk_organization")
  );

  const [imgSource, setImgSource] = useState(SalePointDefaultImg);

  const [salePoint, setSalePoint] = useState({});

  const [loading, setLoading] = useState(true);

  const [courses, setCourses] = useState([]);

  const [organizationCourses, setOrganizationCourses] = useState([]);

  const [formTitle, setFormTitle] = useState("createNewFranchise");

  const [submitLabel, setSubmitLabel] = useState("createFranchiseLbl");

  const [sellPrice, setSellPrice] = useState();

  const [map, setMap] = useState(<div></div>);

  const [latLng, setLatLng] = useState({});

  let newProfilePicture;

  const hiddenFileInput = React.useRef(null);

  const urlLocation = useLocation();

  const [snackbarMessage, setSnackbarMessage] = useState(
    <Alert severity="success">NONE</Alert>
  );

  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [shouldNavigateOnClose, setShouldNavigateOnClose] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  const [selectedCourses, setSelectedCourses] = useState();

  const history = useHistory();

  const colCities = [
    "Bogotá",
    "Medellín",
    "Cali",
    "Barranquilla",
    "Cartagena",
    "Cúcuta",
    "Bucaramanga",
    "Pereira",
    "Santa Marta",
    "Ibagué",
    "Valledupar",
    "Manizales",
    "Pasto",
    "Montería",
    "Neiva",
    "Tunja",
    "Riohacha",
    "Sincelejo",
    "Armenia",
    "Popayán",
    "Villavicencio",
    "Quibdó",
    "Florencia",
    "Yopal",
    "Mocoa",
    "Mitú",
    "San Andrés",
    "Leticia",
    "Puerto Carreño",
  ];

  //Tags management

  const [tags, setTags] = useState();

  const [selectedTags, setSelectedTags] = useState([]);

  const [productsInTags, setProductInTags] = useState([]);

  const [loadingProductsTags, setLoadingProductsTags] = useState(true);
  
  const [businessHours, setBusinessHours] = useState([
    { day: "", startTime: "", endTime: "" }
  ]);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [hourIndexToDelete, setHourIndexToDelete] = useState(null);

  // Estados para formulario de horarios de disponibilidad
  const [scheduleName, setScheduleName] = useState("");
  const [salePoints, setSalePoints] = useState([]);
  const [selectedSalePoints, setSelectedSalePoints] = useState([]);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");
  const [selectedDays, setSelectedDays] = useState({
    Lun: false,
    Mar: false,
    Mié: false,
    Jue: false,
    Vie: false,
    Sáb: false,
    Dom: false,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editingScheduleId, setEditingScheduleId] = useState(null);
  const [actualShowForm, setActualShowForm] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [schedulesLoading, setSchedulesLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pagination, setPagination] = useState({});
  
  // States for multiple schedules
  const [scheduleItems, setScheduleItems] = useState([
    {
      id: null,
      timeFrom: "",
      timeTo: "",
      limitTime: "",
      selectedDays: {
        Lun: false,
        Mar: false,
        Mié: false,
        Jue: false,
        Vie: false,
        Sáb: false,
        Dom: false,
      },
      available_students: true,
      available_employees: true,
      available_caretakers: true,
    }
  ]);
  const [deleteScheduleModalOpen, setDeleteScheduleModalOpen] = useState(false);
  const [scheduleIndexToDelete, setScheduleIndexToDelete] = useState(null);
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [hasExistingSchedules, setHasExistingSchedules] = useState(false);
  const [editingScheduleIndices, setEditingScheduleIndices] = useState(new Set());
  const [unsavedSchedulesModalOpen, setUnsavedSchedulesModalOpen] = useState(false);
  const [pendingSchedules, setPendingSchedules] = useState([]); // Horarios guardados antes de crear el punto de venta

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffffff',
    boxShadow: 24,
    p: 2.5,
    borderRadius: 2,
  };

  function uniques(listA, listB) {
    return listA.filter((objectA) => {
      return !listB.some((objectB) => objectB.id === objectA.id);
    });
  }

  // ----------------------------------------------------
  // ------------------ Async calls ---------------------
  // ----------------------------------------------------

  const fetchData = async () => {
    let fkOrganization = localStorage.getItem("fk_organization");
    getAllSalePointType(fkOrganization).then((data) => {
      let sptOptions = data["sale_points_type"].map(({ id, name }) => ({
        value: id,
        label: name,
      }));
      setSalePointTypeList(sptOptions);
      setLoading(false);
      setLoadingProductsTags(false);
    });
    

    if (urlLocation.pathname.includes("edit")) {
      let salePointId = localStorage.getItem("fk_sale_point");
      setFormTitle("editSalePoint");
      setSubmitLabel("editSalePointlbl");

      await getCoursesBySalePoint(salePointId).then((data1) => {
        setCourses(data1.courses);
        getCoursesByOrganization(organizationId).then((data2) => {
          // const nuevaLista1 = data1.courses.filter(objeto1 => !data2.courses.some(objeto2 => objeto2.id === objeto1.id));


          const list1 = uniques(data2.courses, data1.courses);

          let transformedData = data2.courses.map((spt) => {
            return { label: spt.name, value: spt.id + "" };
          });
          setOrganizationCourses(transformedData);
        });
      });

      await getSalePointById(salePointId).then((data) => {
        let salePointData = data.sale_point;
        setSalePoint(salePointData);
        let salePointTypeData = salePointData.sale_point_type.map(
          ({ id, name }) => ({
            value: id,
            label: name,
          })
        );
        setSelectedSpt(salePointTypeData);
        salePointData.image
          ? setImgSource(salePointData.image)
          : setImgSource(imgSource);
      });

      // Load existing schedules from the sale point
      await getFranchiseSchedule(salePointId).then((data) => {
        if (data.sale_point_schedules && data.sale_point_schedules.length > 0) {
          const convertedSchedules = data.sale_point_schedules.map((schedule) => {
            // Convert time format from "HH:MM:SS" to "HH:MM"
            const timeFrom = schedule.opens_at ? schedule.opens_at.substring(0, 5) : "";
            const timeTo = schedule.closes_at ? schedule.closes_at.substring(0, 5) : "";
            const limitTime = schedule.limit_time ? schedule.limit_time.substring(0, 5) : "";

            // Map days from the API to the component format
            const selectedDays = {
              Lun: schedule.monday === 1,
              Mar: schedule.tuesday === 1,
              Mié: schedule.wednesday === 1,
              Jue: schedule.thursday === 1,
              Vie: schedule.friday === 1,
              Sáb: schedule.saturday === 1,
              Dom: schedule.sunday === 1,
            };

            return {
              id: schedule.id,
              timeFrom: timeFrom,
              timeTo: timeTo,
              limitTime: limitTime,
              selectedDays: selectedDays,
              available_students: schedule.available_students === 1 || false,
              available_employees: schedule.available_employees === 1 || false,
              available_caretakers: schedule.available_caretakers === 1 || false,
            };
          });
          
          setScheduleItems(convertedSchedules);
          setHasExistingSchedules(true);
          setShowScheduleForm(true);
        } else {
          setHasExistingSchedules(false);
        }
      }).catch((error) => {
        console.error("Error al cargar horarios:", error);
        setHasExistingSchedules(false);
      });

      await getCoursesBySalePoint(salePointId).then((data1) => {
        setCourses(data1.courses);
        getCoursesByOrganization(organizationId).then((data2) => {
          // const nuevaLista1 = data1.courses.filter(objeto1 => !data2.courses.some(objeto2 => objeto2.id === objeto1.id));

          let transformedData = data2.courses.map((spt) => {
            return { label: spt.name, value: spt.id + "" };
          });
          setOrganizationCourses(transformedData);
        });
      });

      await getTagsOfSalePoint(salePointId).then((data) => {
        let tagsTransformed = data.tags.map((tag) => {
          let tagsName = tag.name; // You're assigning the tag name to a variable, which is good.
          
          if (tag.type === 1) { 
            tagsName += " (P)"; // Correctly appending " (P)" if tag.type is 1.
          }
          
          return {
            value: tag.id,
            label: tagsName, // Updated to use the correctly formatted tagsName.
            color: tag.color,
          };
        });
        setSelectedTags(tagsTransformed);
      });

      await getRestrictedProductsOfSalePoint(salePointId).then((data) => {
        setProductInTags(data.products);
        setLoadingProductsTags(false);
      });

      await getTagsOfOrganization(fkOrganization).then((data) => {
        let tagsTransformed = data.tags.map((tag) => ({
          value: tag.id,
          label: tag.name,
          color: tag.color,
        }));
        setTags(tagsTransformed);
      });
      // const nuevaLista1 = courses.filter(objeto1 => !organizationCourses.some(objeto2 => objeto2.id === objeto1.id));
      // console.log(nuevaLista1);
      // setOrganizationCourses(nuevaLista1);
      // getFranchisesById(salePointId).then((data) => {

      //   let salePointData = data.sale_point;

      //   setSalePoint(salePointData);
      //   setSelectedSpt(salePointData.sale_point_type);
      //   // setSalePointType(franchiseData.franchise_type);
      //   setSellPrice(salePointData.sales_goal);
      //   salePointData.image
      //     ? setImgSource(salePointData.image)
      //     : setImgSource(imgSource);
      //   if (salePointData.latitude && salePointData.longitude) {
      //     // setMap(
      //     //   <SimpleMap
      //     //     center={{
      //     //       lat: franchiseData.latitude,
      //     //       lng: franchiseData.longitude,
      //     //     }}
      //     //     handleLocationChanged={handleLocationChanged}
      //     //   />
      //     // );
      //   } else {
      //     setMap(<SimpleMap handleLocationChanged={handleLocationChanged} />);
      //   }
      // });
    } else {
      setMap(<SimpleMap handleLocationChanged={handleLocationChanged} />);
    }
  };

  useEffect(() => {
    fetchData().then(() => {});
  }, []);

  useEffect(() => {
    if (selectedTags.length > 0) {
      let salePointId = localStorage.getItem("fk_sale_point");
      let idTags = selectedTags.map((tag) => tag.value);

      let jsonBody = {
        fk_sale_point: salePointId,
        tag_ids: idTags,
      };
      setLoadingProductsTags(true);
      modifyTagWithSalePoint(JSON.stringify(jsonBody)).then((data) => {
        getRestrictedProductsOfSalePoint(salePointId).then((data) => {
          setProductInTags(data.products);
          setLoadingProductsTags(false);
        });
      });
    }
  }, [selectedTags]);

  // ----------------------------------------------------
  // ------------------- Handlers -----------------------
  // ----------------------------------------------------

  const handleEditImageClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleSnackbarClose = (event, reason, success = false) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
    if (successSnackbar && shouldNavigateOnClose) {
      history.push("/pasillos");
      setShouldNavigateOnClose(false);
    }
  };

  const handleOnImageChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile != null) {
      setSalePoint({
        ...salePoint,
        [event.target.name]: event.target.files[0],
      });
      newProfilePicture = newFile;
      const url = URL.createObjectURL(newProfilePicture);
      setImgSource(url);
    }
  };

  const handleInputChangeInner = (event) => {
    setSalePoint({ ...salePoint, [event.target.name]: event.target.value });
  };

  const handleImmediateDeliveryChange = (event) => {
    setSalePoint({
      ...salePoint,
      [event.target.name]: event.target.checked ? 1 : 0,
    });
  };

  // Function to check if there are schedules without saving
  const hasUnsavedSchedules = () => {
    if (!showScheduleForm || scheduleItems.length === 0) {
      return false;
    }
    
    return scheduleItems.some((scheduleItem, index) => {
      // Skip pending schedules (they will be saved when sale point is created)
      if (scheduleItem._isPending) {
        return false;
      }
      
      // A schedule is without saving if:
      if (!scheduleItem.id) {
        const hasTimeData = scheduleItem.timeFrom || scheduleItem.timeTo;
        const hasSelectedDays = Object.values(scheduleItem.selectedDays || {}).some(day => day === true);
        return hasTimeData || hasSelectedDays;
      }
      
      // It is in edit mode (has changes without saving)
      if (editingScheduleIndices.has(index)) {
        return true;
      }
      
      return false;
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // Check if there are schedules without saving
    if (hasUnsavedSchedules()) {
      setUnsavedSchedulesModalOpen(true);
      return;
    }
    
    setSubmitted(true);
    if (selectedSpt.length === 0) {
      setSuccessSnackbar(false);
      setSnackbarMessage(
        <Alert severity="warning">Debe selecionar o crear un pasillo</Alert>
      );
      setOpenSnackbar(true);
      setSubmitted(false);
    } else {
      //TODO check we have all the parameters
      let formDataBody = new FormData();
      let fk_organization = localStorage.getItem("fk_organization");
      formDataBody.append("fk_organization", fk_organization);

      for (const key in salePoint) {
        if (typeof salePoint[key] == File) {
          formDataBody.append(key, salePoint[key], "profilePicture.jpg");
        } else if (key === "electronic_invoice_enabled") {
          formDataBody.append(key, salePoint[key] ? 1 : 0);
        } else if (key === "sales_goal" && typeof salePoint[key] === "string") {
          let sellPrice = salePoint[key];
          let finalPrice = sellPrice.replaceAll(",", "");
          let finalFinal = finalPrice.replace(".", "");
          formDataBody.append(key, finalPrice);
        } else if (salePoint[key] !== undefined) {
          formDataBody.append(key, salePoint[key]);
        }
      }
      //Check the salePoint type
      let spt_array = selectedSpt.map((spt) => {
        if (spt.value !== 0) {
          return spt.value;
        } else {
          return spt.label;
        }
      });
      formDataBody.append("fk_sale_point_types", spt_array.join(","));

      if (latLng.lat !== undefined && latLng.lng !== undefined) {
        formDataBody.append("latitude", latLng.lat);
        formDataBody.append("longitude", latLng.lng);
      }

      if (urlLocation.pathname.includes("edit")) {
        putFranchise(formDataBody).then((data) => {
          if (data.error === undefined) {
            setSuccessSnackbar(true);
            setShouldNavigateOnClose(true);
            setSnackbarMessage(
              <Alert severity="success">
                Se ha actualizado el punto de venta con éxito
              </Alert>
            );
            setOpenSnackbar(true);
          } else {
            setSuccessSnackbar(false);
            setShouldNavigateOnClose(false);
            setSnackbarMessage(
              <Alert severity="error">Error: {data.error}</Alert>
            );
            setOpenSnackbar(true);
          }
          setSubmitted(false);
        });
      } else {
        postFranchise(formDataBody).then(async (data) => {
          if (data.error === undefined) {
            // Get the new sale point ID from the response
            const newSalePointId = data.sale_point?.id || 
                                 data.sale_point_id || 
                                 data.id || 
                                 (data.sale_point && typeof data.sale_point === 'number' ? data.sale_point : null);
            
            // Update salePointId state and localStorage
            if (newSalePointId) {
              setSalePointId(newSalePointId.toString());
              localStorage.setItem("fk_sale_point", newSalePointId.toString());
            }
            
            // Save pending schedules with the new sale point ID
            if (pendingSchedules.length > 0 && newSalePointId) {
              try {
                await savePendingSchedules(newSalePointId.toString());
              } catch (scheduleError) {
                console.error("Error al guardar horarios pendientes:", scheduleError);
                // Show warning but don't block success message
                setSuccessSnackbar(true);
                setSnackbarMessage(
                  <Alert severity="warning">
                    Se creó el punto de venta pero hubo un error al guardar algunos horarios. Por favor, revíselos.
                  </Alert>
                );
                setOpenSnackbar(true);
                setSubmitted(false);
                return;
              }
            }
            
            setSuccessSnackbar(true);
            setShouldNavigateOnClose(true);
            setSnackbarMessage(
              <Alert severity="success">
                Se ha creado el punto de venta con éxito
              </Alert>
            );
            setOpenSnackbar(true);
          } else {
            setSuccessSnackbar(false);
            setShouldNavigateOnClose(false);
            setSnackbarMessage(
              <Alert severity="error">Error: {data.error}</Alert>
            );
            setOpenSnackbar(true);
          }
          setSubmitted(false);
        });
      }
    }
  };

  const checkKeyDown = (event) => {
    if (event.code === "Enter") event.preventDefault();
  };

  const handleLocationChanged = (lat, lng) => {
    setLatLng({ lat: lat, lng: lng });
  };

  const handleAddBusinessHour = () => {
    setBusinessHours([...businessHours, { day: "", startTime: "", endTime: "" }]);
  };

  const handleBusinessHourChange = (index, field, value) => {
    const updatedHours = [...businessHours];
    updatedHours[index][field] = value;
    setBusinessHours(updatedHours);
  };

  // Function to automatically format the time input (HH:MM)
  const handleTimeInputChange = (index, timeField, value) => {
    let cleaned = value.replace(/[^\d:]/g, '');
    if (cleaned === '') {
      const updatedHours = [...businessHours];
      updatedHours[index][timeField] = '';
      setBusinessHours(updatedHours);
      return;
    }
    
    // If the user is writing numbers without ":", add ":" only when it has more than 2 digits
    if (!cleaned.includes(':')) {
      if (cleaned.length > 2) {
        // If it has more than 2 digits, add ":" after the second
        cleaned = cleaned.slice(0, 2) + ':' + cleaned.slice(2, 5);
      }
    }
    
    // Validate format HH:MM
    const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const match = cleaned.match(timeRegex);
    
    if (match) {
      let hours = match[1] || '';
      let minutes = match[2] || '';
      
      // If it doesn't have ":" but has more than 2 digits, separate
      if (!cleaned.includes(':') && cleaned.length > 2) {
        hours = cleaned.slice(0, 2);
        minutes = cleaned.slice(2, 5);
      } else if (!cleaned.includes(':')) {
        // If it doesn't have ":" and has 2 or less digits, they are hours
        hours = cleaned;
        minutes = '';
      }
      
      // Validate hour range (0-23) and minutes (0-59)
      const hoursNum = hours ? parseInt(hours) : -1;
      const minutesNum = minutes ? parseInt(minutes) : -1;
      
      if ((hours === '' || (hoursNum >= 0 && hoursNum <= 23)) &&
          (minutes === '' || (minutesNum >= 0 && minutesNum <= 59))) {
        
        // Don't format with padStart while the user is writing, only save the value
        let formatted = '';
        if (hours && minutes) {
          formatted = hours + ':' + minutes;
        } else if (hours && cleaned.includes(':')) {
          formatted = hours + ':';
        } else if (hours) {
          formatted = hours;
        } else {
          formatted = cleaned;
        }
        
        const updatedHours = [...businessHours];
        updatedHours[index][timeField] = formatted;
        setBusinessHours(updatedHours);
      }
    }
  };

  // Function to format the time when the field loses focus (onBlur)
  const handleTimeBlur = (index, timeField) => {
    const updatedHours = [...businessHours];
    const currentTime = updatedHours[index][timeField] || '';
    
    if (currentTime) {
      const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
      const match = currentTime.match(timeRegex);
      
      if (match) {
        let hours = match[1] || '00';
        let minutes = match[2] || '00';
        
        // Validate and format with zeros to the left only when losing focus
        const hoursNum = parseInt(hours);
        const minutesNum = parseInt(minutes);
        
        if (hoursNum >= 0 && hoursNum <= 23 && minutesNum >= 0 && minutesNum <= 59) {
          const formatted = hours.padStart(2, '0') + ':' + minutes.padStart(2, '0');
          updatedHours[index][timeField] = formatted;
          setBusinessHours(updatedHours);
        }
      }
    }
  };

  const handleRemoveBusinessHour = (index) => {
    const updatedHours = businessHours.filter((_, i) => i !== index);
    setBusinessHours(updatedHours.length > 0 ? updatedHours : [{ day: "", startTime: "", endTime: "" }]);
  };

  const handleOpenDeleteModal = (index) => {
    setHourIndexToDelete(index);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
    setHourIndexToDelete(null);
  };

  const handleConfirmDelete = () => {
    if (hourIndexToDelete !== null) {
      handleRemoveBusinessHour(hourIndexToDelete);
      handleCloseDeleteModal();
    }
  };

  // Functions for availability schedule form
  const fetchSalePoints = async () => {
    try {
      const fkOrganization = localStorage.getItem("fk_organization");
      const response = await getAllSalePoint(fkOrganization);
      const formattedSalePoints = response.sale_points.map((point) => ({
        label: point.name,
        value: point.id,
        ...point,
      }));
      // Add "All" option to the beginning of the list
      setSalePoints([
        { label: "Todos", value: "all", isAll: true },
        ...formattedSalePoints,
      ]);
    } catch (error) {
      console.error("Error fetching sale points:", error);
    }
  };

  const fetchSchedules = async (pageNum, rowsPerPageNum, searchQuery = null) => {
    setSchedulesLoading(true);
    try {
      const data = await getPaginatedProductCategories(pageNum, rowsPerPageNum, searchQuery);
      let scheduleData = data.product_categories.map((schedule) =>
        createScheduleData(
          schedule.name,
          schedule.sale_point_types.length === 1 
            ? schedule.sale_point_types[0].sale_point_type.name 
            : "Multiple",
          schedule.id,
          schedule.days || []
        )
      );
      setSchedules(scheduleData);

      let paginationObject = data.pagination;
      paginationObject.rowsPerPage = rowsPerPageNum;
      paginationObject.page = pageNum;
      setPagination(paginationObject);
      setSchedulesLoading(false);
    } catch (error) {
      console.error("Error fetching schedules:", error);
      setSchedulesLoading(false);
    }
  };

  const createScheduleData = (name, franchiseType, id, days) => {
    return {
      name,
      franchiseType,
      days: Array.isArray(days) ? days.join(", ") : days,
      actions: (
        <img 
          src={EditPrimaryIcon} 
          alt="edit" 
          onClick={(e) => {
            e.preventDefault();
            handleEditSchedule(id);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
    };
  };

  const handleEditSchedule = async (id) => {
    try {
      setEditingScheduleId(id);
      setIsEditing(true);
      setActualShowForm(true);

        // Make sure the sale points are loaded
      let currentSalePoints = salePoints;
      if (currentSalePoints.length === 0) {
        await fetchSalePoints();
        await new Promise(resolve => setTimeout(resolve, 100));
        currentSalePoints = salePoints;
      }

      const data = await getProductCategory(id);
      const schedule = data.product_category;

      setScheduleName(schedule.name || "");

      // Map sale points
      if (schedule.sale_point_types && schedule.sale_point_types.length > 0) {
        // Use the current sale points from the state
        const currentPoints = salePoints.length > 0 ? salePoints : currentSalePoints;
        const regularPoints = currentPoints.filter((point) => !point.isAll);
        const scheduleSalePoints = schedule.sale_point_types.map(({ sale_point_type }) => {
          const found = regularPoints.find(
            (point) => point.value === sale_point_type.id || point.id === sale_point_type.id
          );
          return found || {
            label: sale_point_type.name,
            value: sale_point_type.id,
            id: sale_point_type.id,
          };
        });
        
        if (scheduleSalePoints.length === regularPoints.length && regularPoints.length > 0) {
          setSelectedSalePoints([{ label: "Todos", value: "all", isAll: true }, ...regularPoints]);
        } else {
          setSelectedSalePoints(scheduleSalePoints);
        }
      } else {
        setSelectedSalePoints([]);
      }

      // Map schedules
      if (schedule.time_from) {
        setTimeFrom(schedule.time_from);
      }
      if (schedule.time_to) {
        setTimeTo(schedule.time_to);
      }

      // Map days of the week
      if (schedule.days) {
        const daysMap = {
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        };
        
        if (Array.isArray(schedule.days)) {
          schedule.days.forEach((day) => {
            const dayMap = {
              "Lunes": "Lun",
              "Martes": "Mar",
              "Miércoles": "Mié",
              "Jueves": "Jue",
              "Viernes": "Vie",
              "Sábado": "Sáb",
              "Domingo": "Dom",
              "Lun": "Lun",
              "Mar": "Mar",
              "Mié": "Mié",
              "Jue": "Jue",
              "Vie": "Vie",
              "Sáb": "Sáb",
              "Dom": "Dom",
            };
            const mappedDay = dayMap[day] || day;
            if (daysMap.hasOwnProperty(mappedDay)) {
              daysMap[mappedDay] = true;
            }
          });
        }
        
        setSelectedDays(daysMap);
      }
    } catch (error) {
      console.error("Error al cargar el horario para editar:", error);
      alert("Error al cargar los datos del horario");
    }
  };

  // Handlers para formulario de horarios
  const handleScheduleTimeInputChange = (timeField, value) => {
    let cleaned = value.replace(/[^\d:]/g, '');
    
    if (cleaned === '') {
      if (timeField === 'from') {
        setTimeFrom('');
      } else {
        setTimeTo('');
      }
      return;
    }
    
    if (!cleaned.includes(':')) {
      if (cleaned.length > 2) {
        cleaned = cleaned.slice(0, 2) + ':' + cleaned.slice(2, 5);
      }
    }
    
    const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const match = cleaned.match(timeRegex);
    
    if (match) {
      let hours = match[1] || '';
      let minutes = match[2] || '';
      
      if (!cleaned.includes(':') && cleaned.length > 2) {
        hours = cleaned.slice(0, 2);
        minutes = cleaned.slice(2, 5);
      } else if (!cleaned.includes(':')) {
        hours = cleaned;
        minutes = '';
      }
      
      const hoursNum = hours ? parseInt(hours) : -1;
      const minutesNum = minutes ? parseInt(minutes) : -1;
      
      if ((hours === '' || (hoursNum >= 0 && hoursNum <= 23)) &&
          (minutes === '' || (minutesNum >= 0 && minutesNum <= 59))) {
        
        let formatted = '';
        if (hours && minutes) {
          formatted = hours + ':' + minutes;
        } else if (hours && cleaned.includes(':')) {
          formatted = hours + ':';
        } else if (hours) {
          formatted = hours;
        } else {
          formatted = cleaned;
        }
        
        if (timeField === 'from') {
          setTimeFrom(formatted);
        } else {
          setTimeTo(formatted);
        }
      }
    }
  };

  const handleScheduleTimeBlur = (timeField) => {
    const currentTime = timeField === 'from' ? timeFrom : timeTo;
    
    if (currentTime) {
      const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
      const match = currentTime.match(timeRegex);
      
      if (match) {
        let hours = match[1] || '00';
        let minutes = match[2] || '00';
        
        const hoursNum = parseInt(hours);
        const minutesNum = parseInt(minutes);
        
        if (hoursNum >= 0 && hoursNum <= 23 && minutesNum >= 0 && minutesNum <= 59) {
          const formatted = hours.padStart(2, '0') + ':' + minutes.padStart(2, '0');
          if (timeField === 'from') {
            setTimeFrom(formatted);
          } else {
            setTimeTo(formatted);
          }
        }
      }
    }
  };

  const handleSalePointsChange = (event, newValue, reason) => {
    const regularPoints = salePoints.filter((point) => !point.isAll);
    
    const selectedAll = newValue.some((option) => option?.isAll);
    
    if (selectedAll) {
      setSelectedSalePoints(regularPoints);
    } else if (newValue.length === regularPoints.length && regularPoints.length > 0) {
      setSelectedSalePoints(newValue);
    } else {
      setSelectedSalePoints(newValue);
    }
  };

  const handleDayToggle = (day) => {
    setSelectedDays({
      ...selectedDays,
      [day]: !selectedDays[day],
    });
  };

  // Helper function to convert time HH:MM to minutes (handles partial formats also)
  const timeToMinutes = (time) => {
    if (!time || time === '') return null;
    
    // Try full format HH:MM
    const fullTimeRegex = /^(\d{1,2}):(\d{2})$/;
    const fullMatch = time.match(fullTimeRegex);
    if (fullMatch) {
      const hours = parseInt(fullMatch[1]);
      const minutes = parseInt(fullMatch[2]);
      if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
        return hours * 60 + minutes;
      }
    }
    
    // Try partial format HH: or HH
    const partialTimeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const partialMatch = time.match(partialTimeRegex);
    if (partialMatch) {
      const hours = parseInt(partialMatch[1] || '0');
      const minutes = parseInt(partialMatch[2] || '0');
      if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
        return hours * 60 + minutes;
      }
    }
    
    return null;
  };

  // Function to validate that "To" is greater than "From"
  const validateTimeRange = (timeFrom, timeTo) => {
    if (!timeFrom || !timeTo) return null; // Don't validate if any is empty
    
    // Only validate if both have full format HH:MM
    const fullTimeRegex = /^(\d{1,2}):(\d{2})$/;
    if (!fullTimeRegex.test(timeFrom) || !fullTimeRegex.test(timeTo)) {
      return null; 
    }
    
    const fromMinutes = timeToMinutes(timeFrom);
    const toMinutes = timeToMinutes(timeTo);
    
    if (fromMinutes === null || toMinutes === null) return null;
    
    return toMinutes > fromMinutes;
  };

  const validateLimitTime = (limitTime, timeTo) => {
    if (!limitTime || !timeTo) return null;
    const fullTimeRegex = /^(\d{1,2}):(\d{2})$/;
    if (!fullTimeRegex.test(limitTime) || !fullTimeRegex.test(timeTo)) return null;
    const limitMinutes = timeToMinutes(limitTime);
    const toMinutes = timeToMinutes(timeTo);
    if (limitMinutes === null || toMinutes === null) return null;
    return limitMinutes <= toMinutes;
  };

  // Handlers for multiple schedules (new design)
  const handleAddScheduleItem = () => {
    setScheduleItems([
      ...scheduleItems,
      {
        id: null,
        timeFrom: "",
        timeTo: "",
        selectedDays: {
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        },
        available_students: true,
        available_employees: true,
        available_caretakers: true,
      }
    ]);
  };

  const handleScheduleItemTimeChange = (index, timeField, value) => {
    let cleaned = value.replace(/[^\d:]/g, '');
    
    if (cleaned === '') {
      const updatedItems = [...scheduleItems];
      updatedItems[index][timeField] = '';
      setScheduleItems(updatedItems);
      return;
    }
    
    if (!cleaned.includes(':')) {
      if (cleaned.length > 2) {
        cleaned = cleaned.slice(0, 2) + ':' + cleaned.slice(2, 5);
      }
    }
    
    const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
    const match = cleaned.match(timeRegex);
    
    if (match) {
      let hours = match[1] || '';
      let minutes = match[2] || '';
      
      if (!cleaned.includes(':') && cleaned.length > 2) {
        hours = cleaned.slice(0, 2);
        minutes = cleaned.slice(2, 5);
      } else if (!cleaned.includes(':')) {
        hours = cleaned;
        minutes = '';
      }
      
      const hoursNum = hours ? parseInt(hours) : -1;
      const minutesNum = minutes ? parseInt(minutes) : -1;
      
      if ((hours === '' || (hoursNum >= 0 && hoursNum <= 23)) &&
          (minutes === '' || (minutesNum >= 0 && minutesNum <= 59))) {
        
        let formatted = '';
        if (hours && minutes) {
          formatted = hours + ':' + minutes;
        } else if (hours && cleaned.includes(':')) {
          formatted = hours + ':';
        } else if (hours) {
          formatted = hours;
        } else {
          formatted = cleaned;
        }
        
        const updatedItems = [...scheduleItems];
        updatedItems[index][timeField] = formatted;
        setScheduleItems(updatedItems);
      }
    }
  };

  const handleScheduleItemTimeBlur = (index, timeField) => {
    const updatedItems = [...scheduleItems];
    const currentTime = updatedItems[index][timeField] || '';
    
    if (currentTime) {
      const timeRegex = /^(\d{1,2}):?(\d{0,2})$/;
      const match = currentTime.match(timeRegex);
      
      if (match) {
        let hours = match[1] || '00';
        let minutes = match[2] || '00';
        
        const hoursNum = parseInt(hours);
        const minutesNum = parseInt(minutes);
        
        if (hoursNum >= 0 && hoursNum <= 23 && minutesNum >= 0 && minutesNum <= 59) {
          const formatted = hours.padStart(2, '0') + ':' + minutes.padStart(2, '0');
          updatedItems[index][timeField] = formatted;
          setScheduleItems(updatedItems);
        }
      }
    }
    
    // Validate time range after formatting
    if (updatedItems[index].timeFrom && updatedItems[index].timeTo) {
      const isValid = validateTimeRange(updatedItems[index].timeFrom, updatedItems[index].timeTo);
    }
  };

  const handleScheduleItemDayToggle = (index, day) => {
    const updatedItems = [...scheduleItems];
    updatedItems[index].selectedDays[day] = !updatedItems[index].selectedDays[day];
    setScheduleItems(updatedItems);
  };

  const handleScheduleItemCheckboxToggle = (index, field) => {
    const updatedItems = [...scheduleItems];
    updatedItems[index][field] = !updatedItems[index][field];
    setScheduleItems(updatedItems);
  };

  const handleOpenDeleteScheduleModal = (index) => {
    setScheduleIndexToDelete(index);
    setDeleteScheduleModalOpen(true);
  };

  const handleCloseDeleteScheduleModal = () => {
    setDeleteScheduleModalOpen(false);
    setScheduleIndexToDelete(null);
  };

  const handleConfirmDeleteSchedule = async () => {
    if (scheduleIndexToDelete !== null) {
      const scheduleToDelete = scheduleItems[scheduleIndexToDelete];
      
      // If the schedule has an ID 
      if (scheduleToDelete && scheduleToDelete.id) {
        try {
          const formData = new FormData();
          formData.append("sale_point_schedule_id", scheduleToDelete.id);
          await deleteScheduleFranchise(formData);
          
          // Reload the schedules of the sale point after deleting
          const salePointIdToLoad = salePointId || localStorage.getItem("fk_sale_point");
          if (salePointIdToLoad) {
            await getFranchiseSchedule(salePointIdToLoad).then((data) => {
              if (data.sale_point_schedules && data.sale_point_schedules.length > 0) {
                const convertedSchedules = data.sale_point_schedules.map((schedule) => {
                  const timeFrom = schedule.opens_at ? schedule.opens_at.substring(0, 5) : "";
                  const timeTo = schedule.closes_at ? schedule.closes_at.substring(0, 5) : "";
                  const limitTime = schedule.limit_time ? schedule.limit_time.substring(0, 5) : "";

                  const selectedDays = {
                    Lun: schedule.monday === 1,
                    Mar: schedule.tuesday === 1,
                    Mié: schedule.wednesday === 1,
                    Jue: schedule.thursday === 1,
                    Vie: schedule.friday === 1,
                    Sáb: schedule.saturday === 1,
                    Dom: schedule.sunday === 1,
                  };

                  return {
                    id: schedule.id,
                    timeFrom: timeFrom,
                    timeTo: timeTo,
                    limitTime: limitTime,
                    selectedDays: selectedDays,
                    available_students: schedule.available_students === 1 || false,
                    available_employees: schedule.available_employees === 1 || false,
                    available_caretakers: schedule.available_caretakers === 1 || false,
                  };
                });
                
                setScheduleItems(convertedSchedules);
                setHasExistingSchedules(true);
                setEditingScheduleIndices(new Set());
              } else {
                // If there are no more schedules, reset
                setScheduleItems([{
                  id: null,
                  timeFrom: "",
                  timeTo: "",
                  selectedDays: {
                    Lun: false,
                    Mar: false,
                    Mié: false,
                    Jue: false,
                    Vie: false,
                    Sáb: false,
                    Dom: false,
                  },
                  available_students: true,
                  available_employees: true,
                  available_caretakers: true,
                }]);
                setHasExistingSchedules(false);
                setEditingScheduleIndices(new Set());
              }
            });
          }
          
          setSuccessSnackbar(true);
          setSnackbarMessage(
            <Alert severity="success">
              Se ha eliminado el horario con éxito
            </Alert>
          );
          setOpenSnackbar(true);
        } catch (error) {
          console.error("Error al eliminar el horario:", error);
          setSuccessSnackbar(false);
          setSnackbarMessage(
            <Alert severity="error">Error al eliminar el horario</Alert>
          );
          setOpenSnackbar(true);
          return; 
        }
      } else {
        // if the schedule doesn't have an ID
        const updatedItems = scheduleItems.filter((_, i) => i !== scheduleIndexToDelete);
        setScheduleItems(updatedItems.length > 0 ? updatedItems : [{
          id: null,
          timeFrom: "",
          timeTo: "",
          selectedDays: {
            Lun: false,
            Mar: false,
            Mié: false,
            Jue: false,
            Vie: false,
            Sáb: false,
            Dom: false,
          },
          available_students: true,
          available_employees: true,
          available_caretakers: true,
        }]);
        // If all schedules were deleted, update the state
        if (updatedItems.length === 0) {
          setHasExistingSchedules(false);
        }
        // Clear edit state for the deleted index
        const newEditingIndices = new Set(editingScheduleIndices);
        newEditingIndices.delete(scheduleIndexToDelete);
        const adjustedIndices = new Set();
        newEditingIndices.forEach(idx => {
          if (idx > scheduleIndexToDelete) {
            adjustedIndices.add(idx - 1);
          } else {
            adjustedIndices.add(idx);
          }
        });
        setEditingScheduleIndices(adjustedIndices);
      }
      
      handleCloseDeleteScheduleModal();
    }
  };

  const handleEditScheduleItem = (index) => {
    const newEditingIndices = new Set(editingScheduleIndices);
    newEditingIndices.add(index);
    setEditingScheduleIndices(newEditingIndices);
  };

  // Function to save pending schedules after sale point is created
  const savePendingSchedules = async (newSalePointId) => {
    if (!pendingSchedules || pendingSchedules.length === 0) {
      return;
    }

    const dayMapping = {
      Lun: "monday",
      Mar: "tuesday",
      Mié: "wednesday",
      Jue: "thursday",
      Vie: "friday",
      Sáb: "saturday",
      Dom: "sunday",
    };

    // Save each pending schedule
    const updatedItems = [...scheduleItems];
    
    for (let i = 0; i < pendingSchedules.length; i++) {
      const pendingSchedule = pendingSchedules[i];
      try {
        const opensAt = pendingSchedule.timeFrom + ":00";
        const closesAt = pendingSchedule.timeTo + ":00";

        const formData = new FormData();
        formData.append("fk_sale_point", newSalePointId);
        formData.append("opens_at", opensAt);
        formData.append("closes_at", closesAt);
        if (pendingSchedule.limitTime) formData.append("limit_time", pendingSchedule.limitTime + ":00");

        // Add each day as 0 or 1
        Object.keys(dayMapping).forEach((componentDay) => {
          const apiDay = dayMapping[componentDay];
          const value = pendingSchedule.selectedDays[componentDay] ? 1 : 0;
          formData.append(apiDay, value);
        });

        // Add audience checkboxes
        formData.append("available_students", pendingSchedule.available_students ? 1 : 0);
        formData.append("available_employees", pendingSchedule.available_employees ? 1 : 0);
        formData.append("available_caretakers", pendingSchedule.available_caretakers ? 1 : 0);

        const response = await postScheduleFranchise(formData);
        
        // Extract schedule ID from response
        let scheduleId = null;
        if (typeof response.sale_point_schedule === 'number') {
          scheduleId = response.sale_point_schedule;
        } else if (response.sale_point_schedule?.id) {
          scheduleId = response.sale_point_schedule.id;
        } else if (response.id) {
          scheduleId = response.id;
        } else if (response.sale_point_schedule_id) {
          scheduleId = response.sale_point_schedule_id;
        }

        // Find the schedule item with matching pending ID and update it
        if (scheduleId) {
          const pendingId = pendingSchedule.id;
          const itemIndex = updatedItems.findIndex(item => 
            item.id === pendingId || 
            (item._isPending && item.timeFrom === pendingSchedule.timeFrom && item.timeTo === pendingSchedule.timeTo && 
             JSON.stringify(item.selectedDays) === JSON.stringify(pendingSchedule.selectedDays))
          );
          
          if (itemIndex !== -1) {
            updatedItems[itemIndex] = {
              ...updatedItems[itemIndex],
              id: scheduleId,
              _isPending: false, // Remove pending flag
            };
          }
        }
      } catch (error) {
        console.error("Error al guardar horario pendiente:", error);
        // Continue with other schedules even if one fails
      }
    }

    // Update scheduleItems with the saved schedules
    setScheduleItems(updatedItems);

    // Clear pending schedules
    setPendingSchedules([]);
  };

  const handleSaveScheduleItem = async (index) => {
    const scheduleItem = scheduleItems[index];
    
    // Validate that the fields are complete
    if (!scheduleItem.timeFrom || !scheduleItem.timeTo) {
      alert("Por favor complete los campos de hora (Desde y Hasta)");
      return;
    }

    // Validate time range
    if (!validateTimeRange(scheduleItem.timeFrom, scheduleItem.timeTo)) {
      alert("La hora 'Desde' debe ser menor que 'Hasta'");
      return;
    }

    // Validate that at least one day is selected
    const hasSelectedDay = Object.values(scheduleItem.selectedDays).some(day => day === true);
    if (!hasSelectedDay) {
      alert("Por favor seleccione al menos un día");
      return;
    }

    // Get the current sale point
    const currentSalePointId = salePointId || localStorage.getItem("fk_sale_point");
    const isCreatingNewSalePoint = !urlLocation.pathname.includes("edit") && !currentSalePointId;
    
    // If we're creating a new sale point and it doesn't exist yet, save schedule locally
    if (isCreatingNewSalePoint) {
      // Mark this schedule as saved locally (will be sent to server after sale point is created)
      const tempId = `pending-${Date.now()}-${index}`;
      const updatedItems = [...scheduleItems];
      updatedItems[index] = {
        ...scheduleItem,
        id: tempId, // Temporary ID to mark as saved locally
        _isPending: true, // Flag to identify pending schedules
      };
      
      // Add to pending schedules with the temporary ID
      setPendingSchedules(prev => [...prev, {
        ...scheduleItem,
        index: index,
        id: tempId, // Save temporary ID for matching later
      }]);
      
      setScheduleItems(updatedItems);
      
      // Remove from editing indices
      const newEditingIndices = new Set(editingScheduleIndices);
      newEditingIndices.delete(index);
      setEditingScheduleIndices(newEditingIndices);
      
      // Show success message
      setSuccessSnackbar(true);
      setSnackbarMessage(
        <Alert severity="success">
          El horario se guardará cuando cree el punto de venta
        </Alert>
      );
      setOpenSnackbar(true);
      return;
    }
    
    if (!currentSalePointId) {
      alert("No se encontró el punto de venta. Por favor, guarde primero el punto de venta.");
      return;
    }

    // Convert time from "HH:MM" to "HH:MM:SS"
    const opensAt = scheduleItem.timeFrom + ":00";
    const closesAt = scheduleItem.timeTo + ":00";

    // Map days from the component format to the API format
    const dayMapping = {
      Lun: "monday",
      Mar: "tuesday",
      Mié: "wednesday",
      Jue: "thursday",
      Vie: "friday",
      Sáb: "saturday",
      Dom: "sunday",
    };

    const formData = new FormData();
    
    // If the schedule has an ID, it is an update
    if (scheduleItem.id) {
      formData.append("sale_point_schedule_id", scheduleItem.id);
      formData.append("fk_sale_point", currentSalePointId);
      formData.append("opens_at", opensAt);
      formData.append("closes_at", closesAt);
      if (scheduleItem.limitTime) formData.append("limit_time", scheduleItem.limitTime + ":00");

      // Add each day as 0 or 1
      Object.keys(dayMapping).forEach((componentDay) => {
        const apiDay = dayMapping[componentDay];
        const value = scheduleItem.selectedDays[componentDay] ? 1 : 0;
        formData.append(apiDay, value);
      });

      // Add audience checkboxes
      formData.append("available_students", scheduleItem.available_students ? 1 : 0);
      formData.append("available_employees", scheduleItem.available_employees ? 1 : 0);
      formData.append("available_caretakers", scheduleItem.available_caretakers ? 1 : 0);

      try {
        const response = await putScheduleFranchise(formData);
        
        // Update only the specific schedule in the state without reloading the entire page
        const updatedItems = [...scheduleItems];
        
        // If the response includes the updated schedule, use those data
        if (response && response.sale_point_schedule) {
          const schedule = response.sale_point_schedule;
          const timeFrom = schedule.opens_at ? schedule.opens_at.substring(0, 5) : scheduleItem.timeFrom;
          const timeTo = schedule.closes_at ? schedule.closes_at.substring(0, 5) : scheduleItem.timeTo;
          
          const selectedDays = {
            Lun: schedule.monday === 1,
            Mar: schedule.tuesday === 1,
            Mié: schedule.wednesday === 1,
            Jue: schedule.thursday === 1,
            Vie: schedule.friday === 1,
            Sáb: schedule.saturday === 1,
            Dom: schedule.sunday === 1,
          };
          
          updatedItems[index] = {
            id: schedule.id || scheduleItem.id, // Ensure ID is preserved
            timeFrom: timeFrom,
            timeTo: timeTo,
            selectedDays: selectedDays,
            available_students: schedule.available_students === 1 || false,
            available_employees: schedule.available_employees === 1 || false,
            available_caretakers: schedule.available_caretakers === 1 || false,
          };
        } else {
          // If the schedule is not complete, keep the current data but ensure ID is preserved
          updatedItems[index] = {
            ...scheduleItem,
            id: scheduleItem.id, // Ensure ID is preserved
          };
        }
        
        // Exit edit mode for this schedule
        const newEditingIndices = new Set(editingScheduleIndices);
        newEditingIndices.delete(index);
        
        // Update all states together to ensure the button changes immediately
        setScheduleItems(updatedItems);
        setEditingScheduleIndices(newEditingIndices);
        
        // Show success message
        setSuccessSnackbar(true);
        setSnackbarMessage(
          <Alert severity="success">
            Se ha actualizado el horario con éxito
          </Alert>
        );
        setOpenSnackbar(true);
      } catch (error) {
        console.error("Error al actualizar el horario:", error);
        setSuccessSnackbar(false);
        setSnackbarMessage(
          <Alert severity="error">Error al actualizar el horario</Alert>
        );
        setOpenSnackbar(true);
      }
    } else {
      // It is a new schedule, create
      formData.append("fk_sale_point", currentSalePointId);
      formData.append("opens_at", opensAt);
      formData.append("closes_at", closesAt);
      if (scheduleItem.limitTime) formData.append("limit_time", scheduleItem.limitTime + ":00");

      // Add each day as 0 or 1
      Object.keys(dayMapping).forEach((componentDay) => {
        const apiDay = dayMapping[componentDay];
        const value = scheduleItem.selectedDays[componentDay] ? 1 : 0;
        formData.append(apiDay, value);
      });

      // Add audience checkboxes
      formData.append("available_students", scheduleItem.available_students ? 1 : 0);
      formData.append("available_employees", scheduleItem.available_employees ? 1 : 0);
      formData.append("available_caretakers", scheduleItem.available_caretakers ? 1 : 0);

      try {
        const response = await postScheduleFranchise(formData);
        const updatedItems = [...scheduleItems];
        let scheduleId = null;

        // Check if sale_point_schedule is directly the ID (number) or an object
        if (response.sale_point_schedule) {
          // If sale_point_schedule is a number (the ID directly)
          if (typeof response.sale_point_schedule === 'number') {
            scheduleId = response.sale_point_schedule;
            updatedItems[index] = {
              ...scheduleItem,
              id: scheduleId,
            };
          } 
          // If sale_point_schedule is an object with an id property
          else if (response.sale_point_schedule.id) {
            const schedule = response.sale_point_schedule;
            scheduleId = schedule.id;
            const timeFrom = schedule.opens_at ? schedule.opens_at.substring(0, 5) : scheduleItem.timeFrom;
            const timeTo = schedule.closes_at ? schedule.closes_at.substring(0, 5) : scheduleItem.timeTo;
            
            const selectedDays = {
              Lun: schedule.monday === 1,
              Mar: schedule.tuesday === 1,
              Mié: schedule.wednesday === 1,
              Jue: schedule.thursday === 1,
              Vie: schedule.friday === 1,
              Sáb: schedule.saturday === 1,
              Dom: schedule.sunday === 1,
            };
            
            updatedItems[index] = {
              id: scheduleId,
              timeFrom: timeFrom,
              timeTo: timeTo,
              selectedDays: selectedDays,
              available_students: schedule.available_students === 1 || false,
              available_employees: schedule.available_employees === 1 || false,
              available_caretakers: schedule.available_caretakers === 1 || false,
            };
          }
        } else if (response.id) {
          // If only the ID comes, update with the ID and keep the current data
          scheduleId = response.id;
          updatedItems[index] = {
            ...scheduleItem,
            id: scheduleId,
          };
        } else if (response.sale_point_schedule_id) {
          // If it comes as sale_point_schedule_id
          scheduleId = response.sale_point_schedule_id;
          updatedItems[index] = {
            ...scheduleItem,
            id: scheduleId,
          };
        } else {
          // Try to extract ID from other possible fields
          scheduleId = response.schedule_id || 
                      response.scheduleId || 
                      response.data?.id || 
                      response.data?.schedule_id ||
                      response.data?.sale_point_schedule_id ||
                      (response.data && response.data.sale_point_schedule && response.data.sale_point_schedule.id);
          
          if (scheduleId) {
            updatedItems[index] = {
              ...scheduleItem,
              id: scheduleId,
            };
          } else {
            // If no ID found, try to reload schedules from server as fallback
            console.warn("No ID found in response, attempting to reload schedules. Response:", response);
            
            // Try to reload schedules from the server
            const currentSalePointId = salePointId || localStorage.getItem("fk_sale_point");
            if (currentSalePointId) {
              try {
                const reloadedData = await getFranchiseSchedule(currentSalePointId);
                if (reloadedData.sale_point_schedules && reloadedData.sale_point_schedules.length > 0) {
                  // Find the most recently created schedule (should be the last one or match by time/days)
                  const convertedSchedules = reloadedData.sale_point_schedules.map((schedule) => {
                    const timeFrom = schedule.opens_at ? schedule.opens_at.substring(0, 5) : "";
                    const timeTo = schedule.closes_at ? schedule.closes_at.substring(0, 5) : "";
                    
                    const selectedDays = {
                      Lun: schedule.monday === 1,
                      Mar: schedule.tuesday === 1,
                      Mié: schedule.wednesday === 1,
                      Jue: schedule.thursday === 1,
                      Vie: schedule.friday === 1,
                      Sáb: schedule.saturday === 1,
                      Dom: schedule.sunday === 1,
                    };

                    return {
                      id: schedule.id,
                      timeFrom: timeFrom,
                      timeTo: timeTo,
                      selectedDays: selectedDays,
                      available_students: schedule.available_students === 1 || false,
                      available_employees: schedule.available_employees === 1 || false,
                      available_caretakers: schedule.available_caretakers === 1 || false,
                    };
                  });
                  
                  // Try to find the matching schedule by time and days
                  const matchingSchedule = convertedSchedules.find(s => 
                    s.timeFrom === scheduleItem.timeFrom && 
                    s.timeTo === scheduleItem.timeTo &&
                    JSON.stringify(s.selectedDays) === JSON.stringify(scheduleItem.selectedDays)
                  );
                  
                  if (matchingSchedule && matchingSchedule.id) {
                    scheduleId = matchingSchedule.id;
                    updatedItems[index] = {
                      ...scheduleItem,
                      id: scheduleId,
                    };
                  } else {
                    // If no match found, use the last schedule (most recent)
                    const lastSchedule = convertedSchedules[convertedSchedules.length - 1];
                    if (lastSchedule && lastSchedule.id) {
                      scheduleId = lastSchedule.id;
                      updatedItems[index] = {
                        ...scheduleItem,
                        id: scheduleId,
                      };
                    }
                  }
                }
              } catch (reloadError) {
                console.error("Error al recargar horarios:", reloadError);
              }
            }
          }
        }
        
        // Only proceed if we got a valid ID
        if (scheduleId) {
          // Remove from editing indices if it was there
          const newEditingIndices = new Set(editingScheduleIndices);
          newEditingIndices.delete(index);
          
          // Update all states together to ensure the button changes immediately
          setScheduleItems(updatedItems);
          setEditingScheduleIndices(newEditingIndices);
          setHasExistingSchedules(true);
          
          // show success snackbar
          setSuccessSnackbar(true);
          setSnackbarMessage(
            <Alert severity="success">
              Se ha guardado el horario con éxito
            </Alert>
          );
          setOpenSnackbar(true);
        } else {
          // If no ID received, log the full response and show error
          console.error("No se pudo obtener el ID del horario. Respuesta completa:", response);
          throw new Error("No se recibió un ID válido del servidor. Por favor, revise la consola para más detalles.");
        }
      } catch (error) {
        console.error("Error al guardar el horario:", error);
        setSuccessSnackbar(false);
        setSnackbarMessage(
          <Alert severity="error">Error al guardar el horario</Alert>
        );
        setOpenSnackbar(true);
      }
    }
  };

  const handleAddSchedule = async () => {
    if (!scheduleName || !selectedSalePoints || selectedSalePoints.length === 0 || !timeFrom || !timeTo) {
      alert("Por favor complete todos los campos obligatorios");
      return;
    }

    const selectedDaysArray = Object.keys(selectedDays).filter(
      (day) => selectedDays[day]
    );

    if (selectedDaysArray.length === 0) {
      alert("Por favor seleccione al menos un día");
      return;
    }

    // get sale point ids
    const salePointIds = selectedSalePoints
      .filter((point) => !point.isAll)
      .map((point) => point.value || point.id);

    if (isEditing && editingScheduleId) {
      // edit mode
      const formData = new FormData();
      formData.append("fk_product_category", editingScheduleId);
      formData.append("name", scheduleName);
      formData.append("time_from", timeFrom);
      formData.append("time_to", timeTo);
      formData.append("days", JSON.stringify(selectedDaysArray));
      formData.append("fk_sale_point_types", salePointIds.join(","));

      try {
        await putProductCategory(formData);
        await fetchSchedules(page, rowsPerPage);
        setActualShowForm(false);
        setIsEditing(false);
        setEditingScheduleId(null);
        // reset form
        setScheduleName("");
        setSelectedSalePoints([]);
        setTimeFrom("");
        setTimeTo("");
        setSelectedDays({
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        });
      } catch (error) {
        console.error("Error al actualizar el horario:", error);
        alert("Error al actualizar el horario");
      }
    } else {
      // create mode
      const formData = new FormData();
      const fkOrganization = localStorage.getItem("fk_organization");
      formData.append("fk_organization", fkOrganization);
      formData.append("name", scheduleName);
      formData.append("time_from", timeFrom);
      formData.append("time_to", timeTo);
      formData.append("days", JSON.stringify(selectedDaysArray));
      formData.append("fk_sale_point_types", salePointIds.join(","));

      try {
        await postProductCategory(formData);
        await fetchSchedules(page, rowsPerPage);
        setActualShowForm(false);
        // reset form
        setScheduleName("");
        setSelectedSalePoints([]);
        setTimeFrom("");
        setTimeTo("");
        setSelectedDays({
          Lun: false,
          Mar: false,
          Mié: false,
          Jue: false,
          Vie: false,
          Sáb: false,
          Dom: false,
        });
      } catch (error) {
        console.error("Error al crear el horario:", error);
        alert("Error al crear el horario");
      }
    }
  };

  const handleChangePage = async (newPage) => {
    await fetchSchedules(newPage, rowsPerPage).then(() => {
      setPage(newPage);
    });
  };

  const handleChangeRowsPerPage = async (newRowsPerPage) => {
    await fetchSchedules(0, newRowsPerPage).then(() => {
      setPage(0);
      setRowsPerPage(newRowsPerPage);
    });
  };

  // useEffect to load initial data
  useEffect(() => {
    fetchSalePoints();
    fetchSchedules(page, rowsPerPage);
  }, []);

  // reset form when opening (only if not in edit mode)
  useEffect(() => {
    if (actualShowForm && !isEditing) {
      setScheduleName("");
      setSelectedSalePoints([]);
      setTimeFrom("");
      setTimeTo("");
      setSelectedDays({
        Lun: false,
        Mar: false,
        Mié: false,
        Jue: false,
        Vie: false,
        Sáb: false,
        Dom: false,
      });
      setEditingScheduleId(null);
      setIsEditing(false);
    }
    if (!actualShowForm) {
      setIsEditing(false);
      setEditingScheduleId(null);
    }
  }, [actualShowForm, isEditing]);

  // ----------------------------------------------------
  // -------------------- Render ------------------------
  // ----------------------------------------------------
  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        {snackbarMessage}
      </Snackbar>
      <div className="row">
        <div className="col-8">
          <main className="section-body">
            <h1 className="section-title">
              <FormattedMessage id={formTitle} />
            </h1>
            {!loading && (
              <form
                onSubmit={handleSubmit}
                className="row g-3"
                onKeyDown={(e) => checkKeyDown(e)}
              >
                <div className="d-flex justify-content-center mb-4">
                  <img
                    className="profile-picture"
                    src={imgSource}
                    alt="Avatar"
                  />
                  <div className="icon-container d-flex justify-content-center align-items-center">
                    <img
                      className="icon"
                      src={EditIcon}
                      alt="edit_icon"
                      onClick={handleEditImageClick}
                    />
                  </div>
                </div>
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleOnImageChange}
                  name="file"
                  hidden="hidden"
                  accept=".jpg, .jpeg, .png, .gif"
                />
                <div className="col-6 mb-3">
                  <TextField
                    required
                    variant="standard"
                    className="form-control"
                    id="standard-basic"
                    label={<FormattedMessage id="nameLbl" />}
                    value={salePoint.name ? salePoint.name : ""}
                    name="name"
                    onChange={handleInputChangeInner}
                  />
                </div>
                <div className="mb-3 ">
                  <TextField
                    required
                    variant="standard"
                    className="form-control description-container"
                    id="standard-basic"
                    label={<FormattedMessage id="descriptionLbl" />}
                    value={salePoint.description ? salePoint.description : ""}
                    name="description"
                    onChange={handleInputChangeInner}
                    rows={4}
                    multiline
                  />
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="timezoneInput">
                        <FormattedMessage id="salePointTypelbl" />
                      </label>
                      {salePointTypeList && (
                        <Autocomplete
                          options={salePointTypeList}
                          selectedOptions={selectedSpt}
                          setSelected={setSelectedSpt}
                        />
                      )}
                      {/* {salePointTypesInSalePoint && } */}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <span></span>
                      <TextField
                        variant="standard"
                        className="form-control"
                        id="standard-basic"
                        label={<FormattedMessage id="prefixLbl" />}
                        value={salePoint.preffix ? salePoint.preffix : ""}
                        name="preffix"
                        onChange={handleInputChangeInner}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="timezoneInput">
                        <FormattedMessage id="countryLbl" />
                      </label>
                      <Select
                        required
                        variant="standard"
                        value={
                          salePoint.country !== undefined
                            ? salePoint.country
                            : ""
                        }
                        name="country"
                        onChange={handleInputChangeInner}
                        className="worker-form-select"
                        id="timezoneInput"
                      >
                        <MenuItem value={"Colombia"} key={1}>
                          Colombia
                        </MenuItem>
                      </Select>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="timezoneInput">
                        <FormattedMessage id="cityLbl" />
                      </label>
                      <Select
                        required
                        variant="standard"
                        value={
                          salePoint.city !== undefined ? salePoint.city : ""
                        }
                        name="city"
                        onChange={handleInputChangeInner}
                        className="worker-form-select"
                        id="timezoneInput"
                      >
                        {colCities.map((city) => (
                          <MenuItem value={city} key={city}>
                            {city}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>


                {/* Availability schedules section - Only show in edit mode */}
                {urlLocation.pathname.includes("edit") && (
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h3 className="section-title">Horarios de disponibilidad</h3>
                      {!hasExistingSchedules && (
                        <Button
                          variant={showScheduleForm ? "contained" : "outlined"}
                          onClick={() => setShowScheduleForm(!showScheduleForm)}
                          size="small"
                          startIcon={showScheduleForm ? <RemoveIcon /> : <AddIcon />}
                        >
                          {showScheduleForm ? "Ocultar horarios" : "Agregar horarios"}
                        </Button>
                      )}
                    </div>

                    {/* Schedule cards */}
                    {showScheduleForm && (
                      <>
                        <div className="schedule-cards-container">
                          {scheduleItems.map((scheduleItem, index) => (
                        <div key={index} className="schedule-card">
                          <div className="schedule-card-header">
                            <h3 className="schedule-card-title">
                              {scheduleItem.id ? `Horario ${scheduleItem.timeFrom || ""}-${scheduleItem.timeTo || ""}` : "Nuevo horario"}
                            </h3>
                          </div>
                          
                          <div className="schedule-card-body">
                            <div className="schedule-time-range">
                              <div className="schedule-form-field small-field">
                                <label className="schedule-form-label">Desde (formato 24 horas)</label>
                                <TextField
                                  variant="outlined"
                                  className="schedule-input"
                                  placeholder="HH:MM"
                                  value={scheduleItem.timeFrom || ""}
                                  onChange={(e) => handleScheduleItemTimeChange(index, "timeFrom", e.target.value)}
                                  onBlur={() => handleScheduleItemTimeBlur(index, "timeFrom")}
                                  error={scheduleItem.timeFrom && scheduleItem.timeTo && !validateTimeRange(scheduleItem.timeFrom, scheduleItem.timeTo)}
                                  helperText={
                                    scheduleItem.timeFrom && scheduleItem.timeTo && !validateTimeRange(scheduleItem.timeFrom, scheduleItem.timeTo)
                                      ? "La hora 'Desde' debe ser menor que 'Hasta'"
                                      : ""
                                  }
                                  disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <AccessTimeIcon style={{ color: '#9D9D9D', fontSize: '20px' }} />
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              </div>

                              <div className="schedule-form-field small-field">
                                <label className="schedule-form-label">Hasta (formato 24 horas)</label>
                                <TextField
                                  variant="outlined"
                                  className="schedule-input"
                                  placeholder="HH:MM"
                                  value={scheduleItem.timeTo || ""}
                                  onChange={(e) => handleScheduleItemTimeChange(index, "timeTo", e.target.value)}
                                  onBlur={() => handleScheduleItemTimeBlur(index, "timeTo")}
                                  error={scheduleItem.timeFrom && scheduleItem.timeTo && !validateTimeRange(scheduleItem.timeFrom, scheduleItem.timeTo)}
                                  helperText={
                                    scheduleItem.timeFrom && scheduleItem.timeTo && !validateTimeRange(scheduleItem.timeFrom, scheduleItem.timeTo)
                                      ? "La hora 'Hasta' debe ser mayor que 'Desde'"
                                      : ""
                                  }
                                  disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <AccessTimeIcon style={{ color: '#9D9D9D', fontSize: '20px' }} />
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              </div>

                              <div className="schedule-form-field small-field">
                                <label className="schedule-form-label">Hora límite de preventa</label>
                                <TextField
                                  variant="outlined"
                                  className="schedule-input"
                                  placeholder="HH:MM"
                                  value={scheduleItem.limitTime || ""}
                                  onChange={(e) => handleScheduleItemTimeChange(index, "limitTime", e.target.value)}
                                  onBlur={() => handleScheduleItemTimeBlur(index, "limitTime")}
                                  error={validateLimitTime(scheduleItem.limitTime, scheduleItem.timeTo) === false}
                                  helperText={
                                    validateLimitTime(scheduleItem.limitTime, scheduleItem.timeTo) === false
                                      ? "La hora límite no puede ser mayor que la hora de cierre"
                                      : "Después de esta hora el usuario no podrá hacer una preventa para este horario"
                                  }
                                  disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <AccessTimeIcon style={{ color: '#9D9D9D', fontSize: '20px' }} />
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              </div>
                            </div>

                            {/* Days */}
                            <div className="schedule-form-field">
                              <label className="schedule-form-label">Días de la semana</label>
                              <div className="schedule-days-container">
                                {Object.keys(scheduleItem.selectedDays).map((day) => (
                                  <button
                                    key={day}
                                    type="button"
                                    className={`schedule-day-button ${scheduleItem.selectedDays[day] ? "selected" : ""}`}
                                    onClick={() => handleScheduleItemDayToggle(index, day)}
                                    disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                  >
                                    {day}
                                  </button>
                                ))}
                              </div>
                            </div>

                            {/* Audience checkboxes */}
                            <div className="schedule-form-field">
                              <label className="schedule-form-label">Disponible para:</label>
                              <div className="schedule-checkboxes-container">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={scheduleItem.available_students || false}
                                      onChange={() => handleScheduleItemCheckboxToggle(index, "available_students")}
                                      disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                      color="primary"
                                    />
                                  }
                                  label="Estudiantes"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={scheduleItem.available_employees || false}
                                      onChange={() => handleScheduleItemCheckboxToggle(index, "available_employees")}
                                      disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                      color="primary"
                                    />
                                  }
                                  label="Empleados"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={scheduleItem.available_caretakers || false}
                                      onChange={() => handleScheduleItemCheckboxToggle(index, "available_caretakers")}
                                      disabled={scheduleItem.id && !editingScheduleIndices.has(index)}
                                      color="primary"
                                    />
                                  }
                                  label="Acudientes"
                                />
                              </div>
                            </div>

                            <div className="schedule-card-actions">
                              {scheduleItem.id && !editingScheduleIndices.has(index) ? (
                                <button
                                  type="button"
                                  className="schedule-card-save-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleEditScheduleItem(index);
                                  }}
                                  title="Editar horario"
                                >
                                  Editar
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="schedule-card-save-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleSaveScheduleItem(index);
                                  }}
                                  disabled={validateLimitTime(scheduleItem.limitTime, scheduleItem.timeTo) === false}
                                  title="Guardar horario"
                                >
                                  Guardar horario
                                </button>
                              )}
                              <button
                                type="button"
                                className="schedule-card-close-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleOpenDeleteScheduleModal(index);
                                }}
                                title="Eliminar horario"
                              >
                                Eliminar horario
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                        {/* Button to add more schedules */}
                        <div className="schedule-add-more-container">
                          <Button
                            variant="outlined"
                            className="schedule-add-more-button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAddScheduleItem();
                            }}
                            startIcon={<AddIcon />}
                          >
                            AGREGAR MÁS HORARIOS
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                )}

                
                <div className="row">
                  <div className="col-6">
                  </div>
                </div>

                <div className="row justify-content-end">
                  <div className="col-12 d-flex justify-content-end gap-2">
                    <Link className="" to={`/pasillos`}>
                      <Button variant="outlined">
                        <FormattedMessage id="cancelLbl" />
                      </Button>
                    </Link>
                    <Button variant="contained" type="submit">
                      {!submitted && <FormattedMessage id={submitLabel} />}
                      {submitted && (
                        <div className="d-flex justify-content-center spinner-container">
                          <div
                            className="spinner-border spinner-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </Button>
                  </div>
                </div>
              </form>
            )}
            {loading && (
              <div className="d-flex justify-content-center spinner-container">
                <div className="spinner-border spinner-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </main>
        </div>
        <div className="col-4">
          <div className="row h-50 ">
            <div className="col section-body">
              <div>
                <div className="col-12">
                  <span className="section-title">Productos restringidos</span>
                  <TagInput
                    tags={tags}
                    setTags={setTags}
                    selectedTags={selectedTags}
                    setSelectedTags={setSelectedTags}
                  />
                </div>
              </div>
              {!loadingProductsTags ? (
                <div>
                  <label className="form-label" htmlFor="timezoneInput">
                    Vista previa de productos  (
                    {productsInTags.length})
                  </label>
                  <div className="products-restricted">
                    {productsInTags.map((product) => (
                      <RowProduct product={product} />
                    ))}
                  </div>
                </div>
              ) : (
                <div className="">
                  <div className="d-flex justify-content-center align-items-center spinner-container products-p">
                    <div
                      className="spinner-border spinner-primary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="row h-50">
            <div className="col section-body">
              {!loading ? (
                <>
                  <RelatedCoursesComponent
                    courses={courses}
                    setCourses={setCourses}
                    organizationCourses={organizationCourses}
                    setSelectedCourses={setSelectedCourses}
                    selectedCourses={selectedCourses}
                    salePointId={salePointId}
                    organizationId={organizationId}
                    setOrganizationCourses={setOrganizationCourses}
                  />
                </>
              ) : (
                <>
                  <div className="d-flex justify-content-center spinner-container">
                    <div
                      className="spinner-border spinner-primary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Confirmation modal to delete schedule */}
      <Modal
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-title" variant="h6" component="h2" className="modal-title-confirm">
            Confirmar eliminación
          </Typography>
          <Typography id="modal-description" sx={{ mt: 2 }} className="modal-confirm-edit">
            {hourIndexToDelete !== null && businessHours[hourIndexToDelete] ? (
              (() => {
                const hourToDelete = businessHours[hourIndexToDelete];
                const day = hourToDelete.day || "sin día";
                const startTime = hourToDelete.startTime || "sin hora";
                const endTime = hourToDelete.endTime || "sin hora";
                
                if (day !== "sin día" && startTime !== "sin hora" && endTime !== "sin hora") {
                  return (
                    <>
                      ¿Está seguro de eliminar el horario de {day}
                      <br />
                      de las {startTime} a las {endTime}?
                    </>
                  );
                } else if (day !== "sin día") {
                  return (
                    <>
                      ¿Está seguro de eliminar el horario de {day}?
                    </>
                  );
                } else {
                  return "¿Desea eliminar este horario?";
                }
              })()
            ) : (
              "¿Desea eliminar este horario?"
            )}
          </Typography>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={handleCloseDeleteModal} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleConfirmDelete} variant="contained" autoFocus>
             Aceptar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Confirmation modal to delete availability schedule */}
      <Modal
        open={deleteScheduleModalOpen}
        onClose={handleCloseDeleteScheduleModal}
        aria-labelledby="modal-schedule-title"
        aria-describedby="modal-schedule-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-schedule-title" variant="h6" component="h2" className="modal-title-confirm">
            Confirmar eliminación
          </Typography>
          <Typography id="modal-schedule-description" sx={{ mt: 2 }} className="modal-confirm-edit">
            {scheduleIndexToDelete !== null && scheduleItems[scheduleIndexToDelete] ? (
              (() => {
                const scheduleToDelete = scheduleItems[scheduleIndexToDelete];
                const startTime = scheduleToDelete.timeFrom || "sin hora";
                const endTime = scheduleToDelete.timeTo || "sin hora";
                const selectedDaysList = Object.keys(scheduleToDelete.selectedDays || {})
                  .filter(day => scheduleToDelete.selectedDays[day])
                  .join(", ");
                
                if (startTime !== "sin hora" && endTime !== "sin hora") {
                  return (
                    <>
                      ¿Está seguro de eliminar el horario
                      <br />
                      de las {startTime} a las {endTime}
                      {selectedDaysList && (
                        <>
                          <br />
                          para los días: {selectedDaysList}
                        </>
                      )}
                      ?
                    </>
                  );
                } else {
                  return "¿Desea eliminar este horario?";
                }
              })()
            ) : (
              "¿Desea eliminar este horario?"
            )}
          </Typography>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={handleCloseDeleteScheduleModal} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleConfirmDeleteSchedule} variant="contained" autoFocus>
              Si, eliminar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Warning modal for unsaved schedules */}
      <Modal
        open={unsavedSchedulesModalOpen}
        onClose={() => setUnsavedSchedulesModalOpen(false)}
        aria-labelledby="modal-unsaved-schedules-title"
        aria-describedby="modal-unsaved-schedules-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-unsaved-schedules-title" variant="h6" component="h2" className="modal-title-confirm">
            Horarios sin guardar
          </Typography>
          <Typography id="modal-unsaved-schedules-description" sx={{ mt: 2 }} className="modal-confirm-edit">
            Tiene horarios sin guardar. Por favor, guarde todos los horarios antes de continuar.
          </Typography>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={() => setUnsavedSchedulesModalOpen(false)} variant="contained" autoFocus>
              Entendido
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const Autocomplete = ({ options, selectedOptions, setSelected }) => {
  const handleChange = (newValue, { action }) => {
    setSelected(newValue);
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: 0, label: inputValue };
    setSelected([...selectedOptions, newOption]);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#01A532' : '#9D9D9D',
      boxShadow: state.isFocused ? '0 0 0 1px #01A532' : 'none',
      '&:hover': {
        borderColor: '#01A532',
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#01A532' : state.isFocused ? '#E8F5E8' : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? '#01A532' : '#E8F5E8',
        color: state.isSelected ? 'white' : 'black',
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#01A532',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: 'white',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'white',
      '&:hover': {
        backgroundColor: '#007A28',
        color: 'white',
      },
    }),
  };

  return (
    <CreatableSelect
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      onCreateOption={handleCreateOption}
      required
      isMulti
      isClearable
      isSearchable
      placeholder="Selecciona o crear un tipo de negocio"
      styles={customStyles}
    />
  );
};